import { Container } from "inversify";
import type { IMerchantApprovalRepository } from "../domain/repository/IMerchantApprovalRepository";
import { MerchantApprovalRepositoryImpl } from "../data/repository/MerchantApprovalRepositoryImpl";
import { MerchantApprovalApiService } from "../data/remote/service/MerchantApprovalApiService";

const TYPES = {
  IMerchantApprovalRepository: Symbol.for("IMerchantApprovalRepository"),
};

const merchantApprovalContainer = new Container();

merchantApprovalContainer
  .bind<IMerchantApprovalRepository>(TYPES.IMerchantApprovalRepository)
  .to(MerchantApprovalRepositoryImpl)
  .inSingletonScope();

merchantApprovalContainer
  .bind(MerchantApprovalApiService)
  .toSelf()
  .inSingletonScope();

export { merchantApprovalContainer, TYPES };
